import { useId } from 'react';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export function Input({ label, hint, error, id, className = '', ...rest }: InputProps) {
  const auto = useId();
  const fid = id ?? auto;
  return (
    <div className="vs-field">
      {label && (
        <label className="vs-label" htmlFor={fid}>
          {label}
        </label>
      )}
      <input
        id={fid}
        className={`vs-input ${className}`}
        aria-invalid={error ? 'true' : undefined}
        {...rest}
      />
      {error ? (
        <span className="vs-hint vs-hint--error">{error}</span>
      ) : hint ? (
        <span className="vs-hint">{hint}</span>
      ) : null}
    </div>
  );
}
